import { render, staticRenderFns } from "./IconSvgPhoneEmpty.vue?vue&type=template&id=67467724&scoped=true&"
import script from "./IconSvgPhoneEmpty.vue?vue&type=script&lang=js&"
export * from "./IconSvgPhoneEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67467724",
  null
  
)

export default component.exports